/** @type {import('../types').ProgramConfig} */
export default {
  code: 'MAP',
  displayName: 'Migration Acceleration Program',
  shortName: 'MAP',
  color: 'blue',
  statusLabels: {
    recommend_approval: 'Recommend Approval',
    recommend_rejection: 'Recommend Rejection',
    needs_review: 'Needs Review',
  },
  sidebarItems: [
    { path: '/calculator-check', label: 'Review Calculator', icon: 'status-positive' },
  ],
  listColumns: ['migrationPhase'],

  // Reviewer-feedback panel + validation-summary card.
  // `key` values match the snake_case strings that pre-registry feedback rows
  // store in disagreement_validations (originally Object.keys(detailed_validations)
  // straight from the agent). Confirmed against alpha chronos_reviewer_feedback
  // — historical keys: partner_eligibility, specialized_workload, opportunity_stage,
  // duplicate_funding_requests, technical_requirements, project_timeline.
  // Labels track the detail-page tab names; keys stay fixed so stored rows keep
  // resolving to the current wording.
  feedback: {
    enabled: true,
    validations: [
      { key: 'partner_eligibility',
        label: '1. Partner Eligibility (MMC, MCR status)',
        keywords: ['partner', 'eligibility'] },
      { key: 'specialized_workload',
        label: '2. Specialized Workload (optional - only for specific competencies)',
        keywords: ['specialized workload', 'specialized_workload'] },
      { key: 'opportunity_stage',
        label: '3. Opportunity Details',
        keywords: ['opportunity stage', 'opportunity_stage'] },
      { key: 'mpe_program',
        label: '4. MPE Details',
        keywords: ['mpe program', 'mpe_program'] },
      { key: 'project_timeline',
        label: '5. Project Details',
        keywords: ['timeline', 'project_timeline'] },
      { key: 'pricing_calculator',
        label: '6. Pricing Calculator',
        keywords: ['calculator', 'pricing'] },
      { key: 'technical_requirements',
        label: '7. Technical Review',
        keywords: ['technical requirements', 'technical_requirements'] },
      { key: 'ai_modernization',
        label: '8. Move to AI',
        keywords: ['move to ai', 'ai modernization', 'ai_modernization', 'section d'] },
      { key: 'claims',
        label: '9. Claims',
        keywords: ['claims', 'customer sign-off', 'customer_sign_off'] },
      { key: 'duplicate_funding_requests',
        label: '10. Duplicate Funding Requests (informational only, not counted in total)',
        keywords: ['duplicate'] },
      { key: 'attached_files',
        label: '11. Attached Files (required documents)',
        keywords: ['attached files', 'attached_files'] },
      { key: 'modernization_pathways',
        label: '12. Modernization Pathways (optional - only for modernization incentives)',
        keywords: ['modernization'] },
    ],
    decisionOptions: [
      { value: 'recommend_approval',  label: 'Recommend Approval' },
      { value: 'recommend_rejection', label: 'Recommend Rejection' },
      { value: 'needs_review',        label: 'Needs Review' },
    ],
  },

  // Reviewer-facing manual-check reminders (V2323707533).
  //
  // Display only: no verdict, no threshold, nothing persisted. These are checks
  // Chronos does NOT perform, surfaced so reviewers stop reading a
  // "Recommend Approval" as "every required element on the FR was checked".
  //
  // Rendered at the top of the Project Details tab by renderProjectDetails().
  // Programs that omit this key render no box -- deliberate, and what keeps the
  // reminder off any program that reaches renderProjectDetails() through the
  // PROGRAM_TAB_ALLOWLIST fall-through.
  //
  // Wording is owned by the MAP program owner, not engineering: map_sop.yaml
  // has no section enumerating manual-only reviewer duties, so there is
  // nothing to cite. Adding an item here is a display change, but the text
  // itself still needs program-owner signoff.
  manualChecks: [
    {
      id: 'payer_account_id',
      text: 'Confirm the AWS Account ID on this fund request is a Payer '
        + 'account ID, not a Linked account ID. Chronos validates the ID '
        + 'format only (12 digits, not all zeros) and cannot tell the two apart. '
        + 'A Linked account is ignored by the tagging engine, so no spend '
        + 'accrues against the fund request and the partner\'s claim is at risk.',
    },
  ],
};
